module.exports = __webpack_public_path__ + "img/LS.1cea9a80.svg";